import React, { Component, PropTypes } from "react";

class Filter extends Component {
  static getLabel = filter => {
    if (filter.label) {
      return filter.label;
    }

    if (filter.value) {
      if (filter.options && filter.options.length) {
        return filter.options.find(f => f.value === filter.value).label;
      } else {
        return filter.value;
      }
    } else {
      return "";
    }
  };
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/filter/filters/Filter.js